/// <reference types="jquery" />
/// <reference types="kendo-ui" />

/** Concrete implementation of Hicom popover
*/
class HicomPopover implements IHicomPopover {

    /** Get Kendo template and populate it with the supplied data - MOVE TO UTILS ONCE ONE DEFINED
    * @@param {string} templateId - Id of the script tag of type 'text/x-kendo-template' containing the Kendo template definition
    * @@param {any} data - Data to be supplied to the template
    * @@returns {string} - HTML
    */
    static GetKendoTemplateHtml(templateId = '', data = {}) {
        let $template = kendo.template($(`#${templateId}`).html());
        return $template(data);
    }

    /** Get Partial View content from the supplied URL - MOVE TO UTILS ONCE ONE DEFINED
    * @@param {string} url - GET URL of the partital view action
    * @@returns {string} - HTML
    */
    static GetPartialViewContent(url = '') {
        let retVal = '';

        $.ajax({
            url: url,
            success: function (data, status) {
                retVal = data;
            },
            cache: false,
            async: false
        });

        return retVal;
    }

    /** Generate Hicom popovers where target class data attributes defined
    */
    static _init() {
        let _dropdownTriggersList = [].slice.call(document.querySelectorAll('.hicom-popover-target[data-bs-toggle="dropdown"]'));
        let _dropdownsList = _dropdownTriggersList.map(trigger => {

            /** When the bootstrap dropdown trigger is clicked, BEFORE the dropdown is displayed ask all other dropdown 'popovers' to hide themselves
             *
             */
            trigger.addEventListener('show.bs.dropdown', element => {
                // Close all 'popover' dropdowns except 'this'
                _dropdownTriggersList.forEach(e => {
                    if (element.target.getAttribute('id') != e.getAttribute('id')) {
                        // @ts-ignore
                        bootstrap.Dropdown.getInstance(e).hide();
                    }
                });
            });

            /** When the bootstrap dropdown trigger is clicked, AFTER the dropdown is display refresh the actual content (if dynamically generated)
             *             
             */
            trigger.addEventListener('shown.bs.dropdown', element => {
                let contentType = element.target.getAttribute('data-content-type');
                let $dropDownContentElement = $(element.target.parentElement.querySelector('.dropdown-content'));

                switch (contentType) {
                    case 'Template':
                        let templateContent = HicomPopover.GetKendoTemplateHtml(element.target.getAttribute('data-template-id'), JSON.parse(decodeURIComponent(element.target.getAttribute('data-template-json'))));
                        $dropDownContentElement.html(templateContent);
                        break;

                    case 'PartialView':
                        let partialViewContent = HicomPopover.GetPartialViewContent(element.target.getAttribute('data-partial-url'));
                        $dropDownContentElement.html(partialViewContent);
                        break;

                    case 'Static':
                    default:
                        return;
                        break;
                }
            });

            /** When the dropdown header 'X' is clicked, trigger the hide() as per the user clicking on the trigger icon again
             *             
             */
            trigger.parentElement.querySelector('button.hicom-popover-close').addEventListener('click', element => {
                // @ts-ignore
                bootstrap.Dropdown.getInstance(trigger).hide();
            });

            // @ts-ignore
            return new bootstrap.Dropdown(trigger, {
                popperConfig: function (defaultBsPopperConfig) {
                    // Commented this out as introducing some css that positions the related arrow better
                    //defaultBsPopperConfig.placement = 'bottom-start';

                    defaultBsPopperConfig.modifiers[2] = {
                        "name": "arrow",
                        "options": {
                            "element": ".arrow"
                        }
                    };

                    return defaultBsPopperConfig;
                }
            });
        });
    }
}

/** Concrete implementation of Hicom Telephone fields
*/
class HicomTelephone implements IHicomTelephone {

    /** Get IntlTelInput reference of the Hicom telephone field
    * @@param {string} elementId - Element id
    * @@returns {object} - IntlTelInput reference
    */
    static getInstance(elementId) {
        // @ts-ignore
        return window.intlTelInputGlobals.getInstance(document.getElementById(elementId));
    }

    /** Update the Hicom telephone field 'country code' and 'national' automatically generated fields
    * @@param {string} elementId - Element id
    */
    static UpdateValues(elementId) {
        const ele = document.getElementById(elementId);
        // @ts-ignore
        const intl = window.intlTelInputGlobals.getInstance(ele);
        const countryCodeElement = document.getElementById(ele.dataset.countryCodeElementId);
        const nationalElement = document.getElementById(ele.dataset.nationalElementId);

        if (intl.isValidNumber()) {
            // @ts-ignore
            ele.value = intl.getNumber(); // Hidden mechanism can do thus automatically - but that wont work with Ajax
            // @ts-ignore
            countryCodeElement.value = intl.getSelectedCountryData().dialCode;
            // @ts-ignore
            nationalElement.value = intl.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
        }
    }

    /** Update the Hicom telephone field 'country code' and 'national' automatically generated fields for the entire form
    * @@param {string} formId - form id
    */
    static UpdateValuesForForm(formId) {
        const form = document.getElementById(formId);

        var telephoneElements = form.querySelectorAll('input[data-hicom-role=hicom-telephone]');

        telephoneElements.forEach(ele => {
            HicomTelephone.UpdateValues(ele.id);
        });

    }

}

/** Concrete implementation of Hicom Textarea fields
*/
class HicomTextarea implements IHicomTextarea {

    /** Update the Hicom word count progress field
    * IMPORTANT: This should match the fluent validator in 'HicomValidatorExtensions.cs' - 'MaxWordsValidator'
    */
    static UpdateWordCountLabel(elementId) {

        let ele = <HTMLTextAreaElement>document.getElementById(elementId);
        let target = document.getElementById(`wordcount-${elementId}`);

        // Trim, strip HTML and punctuation, reduce multiple spaces to a single space and split by space to get the count of words
        const value = String(ele.value.trim());

        if (target) {
            // @ts-ignore
            target.innerHTML = value !== '' ? HicomTextUtils.GetWordCount(value) : 0;
        }

    }

    /** Update the Hicom character count progress field
    * IMPORTANT: This should match the fluent validator in 'HicomValidatorExtensions.cs' - 'MaximumLength' validator - so that case it's string.length without trimming
    */
    static UpdateCharacterCountLabel(elementId) {

        let ele = <HTMLTextAreaElement>document.getElementById(elementId);
        let target = document.getElementById(`charactercount-${elementId}`);

        const value = String(ele.value);

        if (target) {
            // @ts-ignore
            target.innerHTML = value.length;
        }

    }

    /**
     * Resize the height of the textarea automatically based on the content
     * @param element
     */
    static AutoResizeHeight(element) {
        element.style.height = 'auto'; // Reset height to allow for shrinking
        element.style.height = element.scrollHeight + 'px'; // Set height based on scrollHeight
    }
}

class HicomTreeView implements IHicomTreeView {

    static SetValidationMessage(id: string, data, message: string): void {

        if (data == null) {
            $('#' + id).append('<li>' + message + '</li>');
        }
    }
}
/**
 * Concrete implementation of Hicom MultiSelect controls 
 */
class HicomMultiSelect implements IHicomMultiSelect {

    /** 
     * Sets the TagMode of a given HicomMultiSelect from Multiple to Single if the number of selected items exceeds the maxSelectedItemsDisplayedInSingleTagMode
     * @param {kendo.ui.MultiSelect} e - The Hicom MultiSelect control
     * @param {number} maxSelectedItemsDisplayedInSingleTagMode - The maximum number of selected items before tag mode changes from Multiple to Single
     */
    static SetTagMode(e: kendo.ui.MultiSelect, maxSelectedItemsDisplayedInSingleTagMode: number) {


        var selectedValues = e.value();
        var currentTagMode = e.options.tagMode;
        var newTagMode = selectedValues.length <= maxSelectedItemsDisplayedInSingleTagMode ? "multiple" : "single";

        if (newTagMode != currentTagMode) {
            e.value([]);
            e.setOptions({ tagMode: newTagMode });
            e.value(selectedValues);
        }
    }

    /**
     *  Selects all items in a given HicomMultiSelect control
     * - find the values - either in the filtered view or the raw data - splice these into the already selected values
     * - clear the textbox value, close the MultiSelect, and trigger its change event and mark as dirty
     * @param { kendo.ui.MultiSelect } multiSelect
     */
    static SelectAllItems(multiSelect: kendo.ui.MultiSelect, dataValueField: string = "Value") {
        let currentValues = multiSelect.value();

        let values = $.map(multiSelect.dataSource.view(), function (dataItem) {
            return dataItem[dataValueField];
        });

        if (!values || values.length == 0) {
            values = $.map(multiSelect.dataSource.data(), function (dataItem) {
                return dataItem[dataValueField];
            });
        }

        currentValues.forEach(function (el) {
            if (values.indexOf(el) === -1) {
                values.push(el);
            }
        })

        multiSelect.input.val("");
        multiSelect.value(values);
        multiSelect.close();
        multiSelect.trigger("change");

        $(multiSelect.element).closest('form.dirtylisten').trigger('dirty.dirtyforms');
    }

    /**
     * Deselects all items in a given HicomMultiSelect control, 
     * - clear the textbox value, close the MultiSelect, and trigger its change event and mark as dirty
     * @param { kendo.ui.MultiSelect } multiSelect
    */
    static DeselectAllItems(multiSelect: kendo.ui.MultiSelect) {
        multiSelect.input.val("");
        multiSelect.value([]);
        multiSelect.close();
        multiSelect.trigger("change");

        $(multiSelect.element).closest('form.dirtylisten').trigger('dirty.dirtyforms');
    }
}

/* Concrete implementation of Hicom MultiSelect controls */
class HicomDropDownTree implements IHicomDropDownTree {
    /** Sets the TagMode of a given HicomMultiSelect from Multiple to Single if the number of selected items exceeds the maxSelectedItemsDisplayedInSingleTagMode
    * @@param {string} id - The id of the dropdown tree
    * @@param {number} maxSelectedItemsDisplayedInMultipleTagMode - The maximum number of selected items before tag mode changes from Multiple to Single
    */

    static SetTagMode(id: string, maxSelectedItemsDisplayedInMultipleTagMode: number) {

        var dropdowntree = $(id).data("kendoDropDownTree");;
        // @ts-ignore
        let selectedValues = [...dropdowntree.value()];
        let currentTagMode = dropdowntree.options.tagMode;

        let newTagMode = currentTagMode;

        newTagMode = selectedValues.length <= maxSelectedItemsDisplayedInMultipleTagMode ? "multiple" : "single";

        // If we need to switch mode then do so...
        if (newTagMode != currentTagMode) {

            setTimeout(function () {

                let thisId = $(id)[0].id;
                let newDropDownTreeInput = $("<input id='" + thisId + "' />");
                let thisHiddenId = $(id)[0].id + "HIDDEN";
                let hiddenInputAnchor = $("<input id='" + thisHiddenId + "' type='hidden'/>");

                if (dropdowntree.element.data("kendoDropDownTree")) {
                    var options;
                    options = dropdowntree.options;
                    options.tagMode = dropdowntree.value().length <= maxSelectedItemsDisplayedInMultipleTagMode ? "multiple" : "single";

                    let thisSelectedValues = $.grep(dropdowntree.value(), function (value) { return value != '0'; })

                    // @ts-ignore
                    options.value = thisSelectedValues; //;
                    dropdowntree.value(thisSelectedValues);

                    // We need to replace our input field with a new one and use this hidden field as a placeholder
                    hiddenInputAnchor.insertBefore($('#' + thisId).parent());

                    dropdowntree.destroy();
                    $(id).parent().remove();
                    newDropDownTreeInput.insertAfter($("#" + thisHiddenId));
                    // Delete placeholder
                    $('#' + thisHiddenId).remove();

                    // Initialise new DropDownTree with the old config
                    $("#" + thisId).kendoDropDownTree(options);
                    let newDDT = $("#" + thisId).data("kendoDropDownTree");

                    if (options.value.length == dropdowntree.value().length) {
                        newDDT.trigger('change');
                    }
                }

            }, 50);

        }
    }
    /** Sets the value of theassociated hidden field 
        * @@param {string} id - id of the DropDownTree
        * @@param {string} idValues - id of the DropDownTree hidden values field
        * @@param {number} maxSelectedItemsDisplayedInMultipleTagMode - The maximum number of selected items before tag mode changes from Multiple to Single
        */
    static SetHiddenValues(id: string, idValues: string, maxSelectedItemsDisplayedInMultipleTagMode: number) {

        var ddt = $(id).data('kendoDropDownTree');

        let thisSelectedValues = $.grep(ddt.value(), function (value) { return value != '0'; })
        $(idValues).val(thisSelectedValues.join(','));

        if (ddt.value().length > 0) {
            this.SetTagMode(id, maxSelectedItemsDisplayedInMultipleTagMode);
        }

    }

    /** Implemented the following function to manipulate how transitioning into into 1 chip appears 
        * @@param {string} id - id of the DropDownTree
        * @@param {number} maxSelectedItemsDisplayedInMultipleTagMode - The maximum number of selected items before tag mode changes from Multiple to Single
        */
    static MultiSelectHousekeeping(id: string, maxSelectedItemsDisplayedInMultipleTagMode: number) {

        let selectedItems = $(id).parent().find('.k-chip-list .k-chip');
        let numberSelectedItems = selectedItems.length;

        if (numberSelectedItems > maxSelectedItemsDisplayedInMultipleTagMode) {
            selectedItems.hide();
            let firstChip = $(id).parent().find('.k-chip-list .k-chip:lt(1)');
            firstChip.find('.k-chip-label').text('Processing...');
            firstChip.find('.k-chip-remove-action').remove();
            firstChip.show();
        }
        else {
            selectedItems.show();
        }

    }


}

/** Concrete implementation of Hicom file uploaded display
*/
class HicomFileUploadedDisplay implements IHicomFileUploadedDisplay {

    /** 'Remove' link click on list currently uploaded files
     * @@param {HTMLAnchorElement} element - Anchor link for 'remove'
     */
    static OnRemove(e: HTMLAnchorElement): void {
        const rowId = e.dataset.rowId;
        const fileName = e.dataset.fileName;
        const url = e.dataset.deleteUrl;

        $("<div></div>").kendoDialog({
            closable: false,
            title: 'Confirm File Removal',
            content: `Are you sure you want to remove the file called '${fileName}'? (this operation cannot be undone)`,
            actions: [{
                text: "Yes",
                action: function (e) {
                    fetch(url, {
                        method: 'DELETE'
                    })
                        .then(data => {
                            if (data.ok) {
                                // Removed deleted row
                                $(`#${rowId}`).remove();
                            } else {
                                $('<div></div>').kendoAlert({
                                    // @ts-ignore
                                    title: "File Removal Error",
                                    content: `Uploaded file could not be removed (${data.status})`
                                }).data('kendoAlert').open();
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                }
            }, {
                text: "No",
                primary: true
            }]
        }).data("kendoDialog").open().center();
    }

    /** 'Remove' link click on list currently uploaded files - deferred mode - makes form dirty
     * @@param {HTMLAnchorElement} element - Anchor link for 'remove'
     */
    static OnDeferredRemove(e: HTMLAnchorElement): void {
        const rowId = e.dataset.rowId;
        const fileName = e.dataset.fileName;
        const deferredDeletedIdsName = e.dataset.deferredDeletedIdsName;
        const deferredDeletedNamesName = e.dataset.deferredDeletedNamesName;
        const fileId = e.dataset.deferredFileEncryptedId;
        const placeholder = $(`#__${deferredDeletedIdsName}`);
        const isDirtyTotalTracker = $(`#__${deferredDeletedIdsName}_Total`);

        $("<div></div>").kendoDialog({
            closable: false,
            title: 'Confirm File Removal',
            content: `Are you sure you want to remove the file called '${fileName}'?`,
            actions: [{
                text: "Yes",
                action: function (e) {
                    // Append file id to deleted list
                    placeholder.append(`<input type='hidden' name='${deferredDeletedNamesName}' value='${fileId}'></input>`);

                    // Update dirty forms tracked total so dirty forms can work as normal
                    isDirtyTotalTracker.val(placeholder.find('input[type=hidden]').length);
                    isDirtyTotalTracker.trigger('change');

                    // Strike through deleted row and display 'Undo' button
                    $(`#${rowId}`).find('.hicom-file-upload-display').css('text-decoration', 'line-through');
                    $(`#${rowId}`).find('.hicom-file-upload-button').hide();
                    $(`#${rowId}`).find('.hicom-file-delete-undo-button').show();
                }
            }, {
                text: "No",
                primary: true
            }]
        }).data("kendoDialog").open().center();
    }

    /** 'Reinstate' deletion of previously uploaded files - deferred mode - makes form dirty
     * @@param {HTMLAnchorElement} element - Anchor link for 'undo'
     */
    static OnDeferredUndo(e: HTMLAnchorElement): void {
        const rowId = e.dataset.rowId;
        const fileName = e.dataset.fileName;
        const deferredDeletedIdsName = e.dataset.deferredDeletedIdsName;
        const deferredDeletedNamesName = e.dataset.deferredDeletedNamesName;
        const fileId = e.dataset.deferredFileEncryptedId;
        const placeholder = $(`#__${deferredDeletedIdsName}`);
        const isDirtyTotalTracker = $(`#__${deferredDeletedIdsName}_Total`);

        $("<div></div>").kendoDialog({
            closable: false,
            title: 'Confirm File Delete Undo',
            content: `Are you sure you want to undo the deletion the file called '${fileName}'?`,
            actions: [{
                text: "Yes",
                action: function (e) {
                    // Remove file id from deleted list
                    placeholder.find(`input[type=hidden][name="${deferredDeletedNamesName}"][value=${fileId}]`).remove();

                    // Update dirty forms tracked total so dirty forms can work as normal
                    isDirtyTotalTracker.val(placeholder.find('input[type=hidden]').length);
                    isDirtyTotalTracker.trigger('change');

                    // Unstrike through and show remove button
                    $(`#${rowId}`).find('.hicom-file-upload-display').css('text-decoration', '');
                    $(`#${rowId}`).find('.hicom-file-upload-button').show();
                    $(`#${rowId}`).find('.hicom-file-delete-undo-button').hide();
                }
            }, {
                text: "No",
                primary: true
            }]
        }).data("kendoDialog").open().center();
    }
}

abstract class HicomHelper implements IHicomHelper {
    private static HICOM_HELPER_LAST_SELECTED_TAB_SESSION_STORAGE_KEY = 'hicom-helper-last-selected-tab-session-storage-key';

    /** Stores the last selected tab ID, per controller/action/tab container, in session storage
    * @@param {string} controller - The current MVC controller
    * @@param {string} action - The current MVC action
    * @@param {string} tabContainerId - The ID of the main tab container in the HTML
    * @@param {string} tabId - The ID of the tab in the HTML
    */
    public static SetLastSelectedTabID(controller: string, action: string, tabContainerId: string, tabId: string) {
        let tabConfig = JSON.parse(sessionStorage[this.HICOM_HELPER_LAST_SELECTED_TAB_SESSION_STORAGE_KEY] || '[]');
        let tabIndex = tabConfig.findIndex(x => x.controller === controller && x.action === action && x.tabContainerId === tabContainerId);

        if (tabIndex > -1) {
            // Item already exists, delete it
            tabConfig.splice(tabIndex, 1);
        }

        let tabConfigData = {
            controller: controller,
            action: action,
            tabContainerId: tabContainerId,
            tabId: tabId
        };

        tabConfig.push(tabConfigData);
        sessionStorage[this.HICOM_HELPER_LAST_SELECTED_TAB_SESSION_STORAGE_KEY] = JSON.stringify(tabConfig);
    }

    /** Gets the last selected tab ID, per controller/action/tab container, from session storage. Returns null if no tab is found
    * @@param {string} controller - The current MVC controller
    * @@param {string} action - The current MVC action
    * @@param {string} tabContainerId - The ID of the main tab container in the HTML
    */
    public static GetLastSelectedTabID(controller: string, action: string, tabContainerId: string): string {
        let tabConfig = JSON.parse(sessionStorage[this.HICOM_HELPER_LAST_SELECTED_TAB_SESSION_STORAGE_KEY] || '[]');
        let tabIndex = tabConfig.findIndex(x => x.controller === controller && x.action === action && x.tabContainerId === tabContainerId);

        if (tabIndex > -1) {
            return tabConfig[tabIndex].tabId;
        }

        return null;
    }

    /** Clears all last selected tab IDs for a specified controller/action, from session storage
    * @@param {string} controller - The current MVC controller
    * @@param {string} action - The current MVC action
    */
    public static ClearLastSelectedTabID(controller: string, action: string): void {
        let tabConfig = JSON.parse(sessionStorage[this.HICOM_HELPER_LAST_SELECTED_TAB_SESSION_STORAGE_KEY] || '[]');
        tabConfig = tabConfig.filter(x => !(x.controller === controller && x.action === action));
        sessionStorage[this.HICOM_HELPER_LAST_SELECTED_TAB_SESSION_STORAGE_KEY] = JSON.stringify(tabConfig);
    }

    /** Sets focus on the specified element. Opens the element's containing tab, if there is one
    * @@param {string} id - The ID of the element on which to focus
    */
    public static FocusOnFormControl(id) {
        let element: HTMLElement = document.getElementById(id);
        if (!element) {
            return;
        }

        // Is the control inside a Bootstrap tab?
        let parentTabContainer: HTMLElement = $(element).parents('[role="tabpanel"]')[0];
        if (parentTabContainer) {
            // Yes - we have the container, which should be linked by an attribute to the name of the tab:
            let tabName: string = parentTabContainer.getAttribute("aria-labelledby");
            if (tabName) {
                // All good - open the tab:
                // @ts-ignore
                var tab = new bootstrap.Tab(document.getElementById(tabName));
                tab && tab.show();
            }
        }

        // Now attempt to apply focus to the relevant form control:
        var focusFn = this.GetFocusFunctionById(id);
        if (focusFn) {
            setTimeout(function () { focusFn(); }, 100);
        }
    }

    private static GetFocusFunctionById(id): Function {
        var element: HTMLElement = document.getElementById(id);
        if (!element) { return null; }

        let hicomRole = String(element.dataset?.hicomRole);

        if (hicomRole) {
            let kendoElement = null;
            switch (hicomRole) {
                case "hicom-dropdown-list":
                    kendoElement = $("#" + id).data("kendoDropDownList");
                    break;
                case "hicom-dropdown-tree":
                    kendoElement = $("#" + id).data("kendoDropDownTree");
                    break;
                case "hicom-multiselect":
                    kendoElement = $("#" + id).data("kendoMultiSelect");
                    break;
            }

            if (kendoElement) {
                return function () { kendoElement.focus(); }
            }
        }

        return function () { element.focus({ preventScroll: false }); }
    }

    /** Update the value of date time fields to send a timezone where necessary
    * @@param {string} formId - form id
    */
    static UpdateDateTimeOffsetValuesForForm(formId) {
        const form = document.getElementById(formId);

        var dateTimeOffsetElements = form.querySelectorAll('input[data-hicom-role=hicom-datetimeoffset]');

        dateTimeOffsetElements.forEach(el => {
            const element = el as HTMLInputElement;

            if (element) {
                let offset: string = element.dataset["timezoneOffset"];
                if (offset) {
                    // Append the timezone to the input's value. This follows the ISO 8601 standard
                    element.type = "text"; // Change it to a text input, as a datetime-local won't accept a timezone
                    element.value += offset;
                }
            }
        });
    }
}

class HicomPassword implements IHicomPassword {

    /** Toggle the Hicom Password reveal input type + icon classes
    */
    static TogglePasswordReveal($element: object, passwordElementId: string) {
        let $passwordElement = $(`#${passwordElementId}`);
        $passwordElement.attr('type', $passwordElement.attr('type') === 'password' ? 'text' : 'password');
        // @ts-ignore
        $element.toggleClass('icon-show');
        // @ts-ignore
        $element.toggleClass('icon-hide');
    }
}

class HicomDateTime {

    static SetDateToNow(dateControlId) {
        // @ts-ignore
        let currentDate = moment(new Date()).format("yyyy-MM-DD");
        let $control = $(`#${dateControlId.id}`);
        $control.val(currentDate).trigger('change').trigger('keyup');
    }

    static SetDateTimeToNow(dateControlId) {
        // @ts-ignore
        let currentDateTime = moment(new Date()).format("yyyy-MM-DDTHH:mm");
        let $control = $(`#${dateControlId.id}`);
        $control.val(currentDateTime).trigger('change').trigger('keyup');
    }


    static SetTimeToNow(dateControlId) {
        // @ts-ignore
        let currentTime = moment(new Date()).format("HH:mm");
        let $control = $(`#${dateControlId.id}`);
        $control.val(currentTime).trigger('change').trigger('keyup');
    }
}
class HicomTabs {

    /** Initialise the tabs for load on demand
    */
    static InitialiseLoadOnDemand(hicomPage: HicomPage) {
        const allTabs = document.querySelectorAll('button[data-bs-toggle="tab"]')
        allTabs.forEach(el => {
            el.addEventListener('shown.bs.tab', e => {
                // @ts-ignore
                let tab = document.querySelector(e.target.getAttribute('data-bs-target'));
                if (tab.getAttribute('data-url') && tab.getAttribute('data-url-loaded') != 'true') {
                    // @ts-ignore
                    hicomPage.loadHtml(tab.getAttribute('data-url'), e.target.getAttribute('data-bs-target'));
                }
            });
        });
    }
}

class HicomTooltip implements IHicomTooltip {

    /** Load all tool tips
    */
    static LoadTooltips() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            // @ts-ignore
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }

    /** Toggle the Hicom Toggle text content - destroy Bootstrap tooltip and recreate as content is to change
    */
    static ToggleToolTipText($element: object, originalTitle: string, newTitle: string) {
        // @ts-ignore
        var lastTitle = $element.attr('data-bs-original-title');
        // @ts-ignore
        $element.attr('data-bs-original-title', lastTitle === originalTitle ? newTitle : originalTitle);
        // @ts-ignore
        $element.tooltip('dispose').tooltip().tooltip('show');
    }
}

/**
 * Type of Hicom date range picker - defaults to data capure (e.g. used of CRUD form)
 */
enum HicomDateRangePickerType {
    DataCapture,
    GridFilter
}

/**
* Hicom functions to wrap date range picker (see 'https://www.daterangepicker.com/') - requires moment.js (see 'https://momentjs.com/')
*/
class HicomDateRangePicker implements IHicomDateRangePicker {

    // Hicom date picker INPUT tag - data attribute holds the element to POST with the selected START DATE is ISO FORMAT
    public static HICOM_DATE_PICKER_START_DATE_DATE_ATTR_NAME = 'start-date-field';

    // Hicom date picker INPUT tag - data attribute holds the element to POST with the selected END DATE is ISO FORMAT
    public static HICOM_DATE_PICKER_END_DATE_DATE_ATTR_NAME = 'end-date-field';

    // Server-side will supply start and end date separated by the ASCII unit delimiter
    public static UNIT_DELIMITER = String.fromCharCode(31);

    // Server-side requires start and end date as an ISO date - Kendo expects proper case
    public static KENDO_FORMAT_ISO_DATE_ONLY_FORMAT = 'yyyy-MM-dd';

    // Date separator (manual in case we change it)
    public static DATE_RANGE_PICKER_DISPLAY_SEPARATOR = ' - ';

    /**
     * Split the start and end dates by ASCII delimiter - then convert from ISO format to whatever the current Kendo UI culture 'd' pattern is set to (see 'HicomGrid' for similar use of Kendo/'d' format specifier)
     * @param $dateRangePicker - jQuery reference to the date picker INPUT element
     * @oaram kendoCultureShortDatePattern - Kendo short date pattern (e.g. 'd' as per Hicom Grid)
     */
    static SetLocalisedDateRange(datePickerElementName: string, kendoCultureShortDatePattern: string) {
        let $dateRangePicker = $(`input[name="${datePickerElementName}"]`);
        let isoDate = String($dateRangePicker.val());

        if (isoDate != '') {
            let dates = Array.from(isoDate.split(HicomDateRangePicker.UNIT_DELIMITER));
            let formattedDates = [];
            if (dates.length > 0) {
                dates.forEach(d => {
                    // @ts-ignore
                    formattedDates.push(kendo.toString(kendo.parseDate(d, HicomDateRangePicker.KENDO_FORMAT_ISO_DATE_ONLY_FORMAT), kendoCultureShortDatePattern));
                });
                $dateRangePicker.val(formattedDates.join(HicomDateRangePicker.DATE_RANGE_PICKER_DISPLAY_SEPARATOR));
            }
        }
    }

    /**
     * Update the actual start and end date INPUT elements with the current values selected in the date picker into the ISO date format
     * @param datePickerElementName - Name of the date picker INPUT element
     */
    static SetISODateRange(datePickerElementName: string) {
        let $dateRangePicker = $(`input[name="${datePickerElementName}"]`);
        let dateRangePicker = $dateRangePicker.data('daterangepicker');
        let startDateElementName = $dateRangePicker.data(HicomDateRangePicker.HICOM_DATE_PICKER_START_DATE_DATE_ATTR_NAME);
        let endDateElementName = $dateRangePicker.data(HicomDateRangePicker.HICOM_DATE_PICKER_END_DATE_DATE_ATTR_NAME);

        if (dateRangePicker.startDate != null) {
            $(`input[name="${startDateElementName}"]`).val(kendo.toString(dateRangePicker.startDate.toDate(), HicomDateRangePicker.KENDO_FORMAT_ISO_DATE_ONLY_FORMAT));
        } else {
            $(`input[name="${startDateElementName}"]`).val('');
        }

        if (dateRangePicker.endDate != null) {
            $(`input[name="${endDateElementName}"]`).val(kendo.toString(dateRangePicker.endDate.toDate(), HicomDateRangePicker.KENDO_FORMAT_ISO_DATE_ONLY_FORMAT));
        } else {
            $(`input[name="${endDateElementName}"]`).val('');
        }
    }

    _type: HicomDateRangePickerType;
    _datePickerElementName: string;
    _$datePicker: JQuery<HTMLElement>;
    _kendoCultureShortDatePattern: string;

    /**
     * Construct date picker - change handler updates the shadow ISO start and end date elements
     * @param datePickerElementName
     * @param kendoCultureShortDatePattern
     */
    constructor(datePickerElementName: string,
        kendoCultureShortDatePattern: string,
        type: HicomDateRangePickerType = HicomDateRangePickerType.DataCapture,
        defaultDateRange: string = 'Today') {
        this._datePickerElementName = datePickerElementName;
        this._kendoCultureShortDatePattern = kendoCultureShortDatePattern;
        this._$datePicker = $(`input[name="${this._datePickerElementName}"]`);

        let initStartDate = null;
        let initEndDate = null;
        switch (defaultDateRange) {
            case 'Today':
                // @ts-ignore
                initStartDate = moment(); initEndDate = moment();
                break;
            case 'Yesterday':
                // @ts-ignore
                initStartDate = moment().subtract(1, 'days'); initEndDate = moment().subtract(1, 'days');
                break;
            case 'Last 7 Days':
                // @ts-ignore
                initStartDate = moment().subtract(6, 'days'); initEndDate = moment();
                break;
            case 'Last 30 Days':
                // @ts-ignore
                initStartDate = moment().subtract(29, 'days'); initEndDate = moment();
                break;
            case 'This Month':
                // @ts-ignore
                initStartDate = moment().startOf('month'); initEndDate = moment().endOf('month');
                break;
            case 'Last Month':
                // @ts-ignore
                initStartDate = moment().subtract(1, 'month').startOf('month'); initEndDate = moment().subtract(1, 'month').endOf('month');
                break;

        }

        switch (type) {
            // For data capture we effectively need to keep the 2 ISO date fields in sync with any operations
            case HicomDateRangePickerType.DataCapture:
                // IMPORTANT: Transpose the loaded ISO-formatted date ranges into the current Kendo locale
                HicomDateRangePicker.SetLocalisedDateRange(datePickerElementName, kendoCultureShortDatePattern);

                let isInitiallyBlank = String(this._$datePicker.val()) == '';

                if (!isInitiallyBlank) {
                    // @ts-ignore
                    initStartDate = moment(this._$datePicker.val().split(HicomDateRangePicker.DATE_RANGE_PICKER_DISPLAY_SEPARATOR)[0].trim(), 'DD/MM/YYYY');
                    // @ts-ignore
                    initEndDate = moment(this._$datePicker.val().split(HicomDateRangePicker.DATE_RANGE_PICKER_DISPLAY_SEPARATOR)[1].trim(), 'DD/MM/YYYY');
                }

                // @ts-ignore
                this._$datePicker.daterangepicker({
                    // @ts-ignore
                    startDate: initStartDate,
                    // @ts-ignore
                    endDate: initEndDate,
                    autoUpdateInput: false,
                    alwaysShowCalendars: true,
                    locale: {
                        cancelLabel: 'Clear',
                        format: this._kendoCultureShortDatePattern.toUpperCase()
                    },
                    ranges: {
                        // @ts-ignore
                        'Today': [moment(), moment()],
                        // @ts-ignore
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        // @ts-ignore
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        // @ts-ignore
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        // @ts-ignore
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        // @ts-ignore
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                    }
                }, function (start, end, label) {
                    // Update picker display
                    this.element.val(`${this.startDate.format(this.locale.format)}${HicomDateRangePicker.DATE_RANGE_PICKER_DISPLAY_SEPARATOR}${this.endDate.format(this.locale.format)}`);
                    this.element.trigger('change');

                    // Update ISO start and end dates
                    HicomDateRangePicker.SetISODateRange(this.element.attr('name'));
                }).on('cancel.daterangepicker', function (e, picker) {
                    // Clear picker display
                    picker.element.val(``);
                    picker.element.trigger('change');

                    // Update ISO start and end dates manually as we've only cleared the display (we can't NULL the internal date(s))

                    let hdnStartDate = $(`input[name="${picker.element.data(HicomDateRangePicker.HICOM_DATE_PICKER_START_DATE_DATE_ATTR_NAME)}"]`);
                    let hdnEndDate = $(`input[name="${picker.element.data(HicomDateRangePicker.HICOM_DATE_PICKER_END_DATE_DATE_ATTR_NAME)}"]`);

                    hdnStartDate.val('');
                    hdnEndDate.val('');

                    HicomDirtyForms.setDirtyStatus(hdnStartDate, hdnStartDate.val());
                    HicomDirtyForms.setDirtyStatus(hdnEndDate, hdnEndDate.val());

                    // set the start and end dates to your desired values
                    // @ts-ignore
                    picker.setStartDate(initStartDate);
                    // @ts-ignore
                    picker.setEndDate(initEndDate);

                }).on('apply.daterangepicker', function (ev, picker) {
                    $(this).val(picker.startDate.format(picker.locale.format) + HicomDateRangePicker.DATE_RANGE_PICKER_DISPLAY_SEPARATOR + picker.endDate.format(picker.locale.format));

                    let hdnStartDate = $(`input[name="${picker.element.data(HicomDateRangePicker.HICOM_DATE_PICKER_START_DATE_DATE_ATTR_NAME)}"]`);
                    let hdnEndDate = $(`input[name="${picker.element.data(HicomDateRangePicker.HICOM_DATE_PICKER_END_DATE_DATE_ATTR_NAME)}"]`);

                    hdnStartDate.val(picker.startDate.format('YYYY-MM-DD'));
                    hdnEndDate.val(picker.endDate.format('YYYY-MM-DD'));


                    HicomDirtyForms.setDirtyStatus(hdnStartDate, hdnStartDate.val());
                    HicomDirtyForms.setDirtyStatus(hdnEndDate, hdnEndDate.val());

                });

                // Initial ISO dates
                HicomDateRangePicker.SetISODateRange(this._datePickerElementName);

                // Blank ISO elements (as internal change handler will default to today and as with the clear option we can't NULL the internal dates)
                if (isInitiallyBlank) {
                    let startDateElementName = this._$datePicker.data(HicomDateRangePicker.HICOM_DATE_PICKER_START_DATE_DATE_ATTR_NAME);
                    let endDateElementName = this._$datePicker.data(HicomDateRangePicker.HICOM_DATE_PICKER_END_DATE_DATE_ATTR_NAME);

                    $(`input[name="${startDateElementName}"]`).val('');
                    $(`input[name="${endDateElementName}"]`).val('');
                }

                break;

            // For a grid filter we just need to worry about ourselves
            case HicomDateRangePickerType.GridFilter:
                // @ts-ignore
                this._$datePicker.daterangepicker({
                    // @ts-ignore
                    startDate: initStartDate,
                    // @ts-ignore
                    endDate: initStartDate,
                    autoUpdateInput: false,
                    alwaysShowCalendars: true,
                    locale: {
                        cancelLabel: 'Clear',
                        format: this._kendoCultureShortDatePattern.toUpperCase()
                    },
                    ranges: {
                        // @ts-ignore
                        'Today': [moment(), moment()],
                        // @ts-ignore
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        // @ts-ignore
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        // @ts-ignore
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        // @ts-ignore
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        // @ts-ignore
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                    }
                }, function (start, end, label) {
                    // Update picker display
                    this.element.val(`${this.startDate.format(this.locale.format)}${HicomDateRangePicker.DATE_RANGE_PICKER_DISPLAY_SEPARATOR}${this.endDate.format(this.locale.format)}`);
                }).on('cancel.daterangepicker', function (e, picker) {
                    // Clear picker display
                    picker.element.val(``);

                    // set the start and end dates to your desired values
                    // @ts-ignore
                    picker.setStartDate(initStartDate);
                    // @ts-ignore
                    picker.setEndDate(initEndDate);

                }).on('apply.daterangepicker', function (ev, picker) {
                    $(this).val(picker.startDate.format(picker.locale.format) + HicomDateRangePicker.DATE_RANGE_PICKER_DISPLAY_SEPARATOR + picker.endDate.format(picker.locale.format));

                    $(`input[name="${picker.element.data(HicomDateRangePicker.HICOM_DATE_PICKER_START_DATE_DATE_ATTR_NAME)}"]`).val(picker.startDate.format('YYYY-MM-DD'));
                    $(`input[name="${picker.element.data(HicomDateRangePicker.HICOM_DATE_PICKER_END_DATE_DATE_ATTR_NAME)}"]`).val(picker.endDate.format('YYYY-MM-DD'));

                });
                break;
        }
    }
}


//#region IPageStateComponent implementations to work with PageState

/**
 * IPageStateComponent implementation for Accordion.
 * 
 * Provides the mechanism for Accordion to use and persist state on a HicomPage
 */
class PageStateAccordion implements IPageStateComponent {
    pageState: PageState;

    constructor(pageState: PageState) {
        // @ts-ignore
        this.pageState = pageState;
        this._init();
    }

    /** 
     * Initialisation of PageStateAccordion. This will execute when the page loaded and "ready".
     */
    _init() {
        const allAccordions = document.querySelectorAll('.collapse')
        allAccordions.forEach(el => {

            /**
             * Detect if the data-save-state attribute is present. If it is then if the value is false, then we simply exit this iteration.
             * Behaviour will be, if false, expander will be collapsed on page refresh, as the state is not saved to session 'tab' storage.
             * Default behaviour is true, meaning the state will be saved and the expander will be based on the stored state.
             */
            let component: HTMLElement = <HTMLElement>el;
            let attrSaveState = component.attributes.getNamedItem("data-save-state");

            if (attrSaveState && attrSaveState.value?.toLowerCase() === "false") {
                return;
            }

            /**
             * Functionality to construct state for changes to every instance and call _savePageState to update page state with the new state data.
             */
            el.addEventListener('shown.bs.collapse', event => {
                console.debug('PageStateAccordion: shown.bs.collapse');

                let key = el.id;
                // @ts-ignore
                let state = true;
                this._savePageState(key, state);
            });
            el.addEventListener('hidden.bs.collapse', event => {
                console.debug('PageStateAccordion: hidden.bs.collapse');

                let key = el.id;
                // @ts-ignore
                let state = false;
                this._savePageState(key, state);
            });

            /**
             * Functionality to call _retrievePageState for every instance and apply state to the UI.
             */
            console.debug('PageStateAccordion: loading state');
            let accordionState = this._retrievePageState(el.id)

            if (accordionState && accordionState.state === true) {
                if (el.getAttribute('data-url-loaded') != 'true') {
                    // @ts-ignore
                    (new bootstrap.Collapse(el)).show();
                }
            }
        });
    }

    _savePageState(key: string, state: any): void {
        const tabState = {
            key: key,
            state: state
        };

        console.debug('ACCORDION: _savePageState');
        this.pageState.setPageStateItem(key, tabState);
    }

    _retrievePageState(key: string): any {
        return this.pageState.getPageStateItem(key);
    }
}


/**
 * IPageStateComponent implementation for Tabs.
 * 
 * Provides the mechanism for Tabs to use and persist state on a HicomPage
 */
class PageStateTabs implements IPageStateComponent {
    pageState: PageState;

    constructor(pageState: PageState) {
        // @ts-ignore
        this.pageState = pageState;
        this._init();
    }

    /** 
     * Initialisation of PageStateTabs. This will execute when the page loaded and "ready".
     */
    _init() {
        /**
         * Functionality to construct state for changes to every instance and call _savePageState to update page state with the new state data.
         */
        const allTabs = document.querySelectorAll('button[data-bs-toggle="tab"]')
        allTabs.forEach(el => {
            el.addEventListener('shown.bs.tab', event => {
                console.debug('PageStateTabs: shown.bs.tab');

                let key = el.closest('[role="tablist"]')?.id;
                // @ts-ignore
                let state = event.target.id;
                this._savePageState(key, state);
            });
        })

        /**
         * Functionality to call _retrievePageState for every instance and apply state to the UI.
         */
        const allTabLists = document.querySelectorAll('[role="tablist"]:not([data-bypass-selected-tab-retention="true"])');
        allTabLists.forEach(el => {
            console.debug('PageStateTabs: loading state');
            let tabState = this._retrievePageState(el.id);

            if (tabState) {
                let lastSelectedTab = document.querySelector(`#${tabState.state}`);
                if (lastSelectedTab && lastSelectedTab.getAttribute('data-url-loaded') != 'true') {
                    // @ts-ignore
                    (new bootstrap.Tab(lastSelectedTab)).show();
                }
            }
        })
    }

    _savePageState(key: string, state: any): void {
        const tabState = {
            key: key,
            state: state
        };

        console.debug('TAB: _savePageState');
        this.pageState.setPageStateItem(key, tabState);
    }

    _retrievePageState(key: string): any {
        return this.pageState.getPageStateItem(key);
    }
}
//#endregion

